<nav aria-label="ts-breadcrumb">
  <ol class="ts-breadcrumb">
    <ng-container *ngFor="let item of items">
      <li class="ts-breadcrumb__item" [class.ts-breadcrumb__item--disabled]="item.disabled">
        <a *ngIf="item.routerLink" [routerLink]="item.routerLink" [queryParams]="item.queryParams">
          <ts-icon [icon]="item.icon" *ngIf="item.icon"></ts-icon>
          {{ item.label }}
        </a>
        <span *ngIf="!item.routerLink" (click)="onItemClick($event, item)">{{ item.label }}</span>
      </li>
    </ng-container>
  </ol>
</nav>
